// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Notifications : styles communs à la liste et au formulaire ===== */

/* rouge plus foncé que --danger, pour que le texte blanc atteigne un contraste de 4.5:1 */
.notifications_page {
  --notifications-danger: #B91C1C;
}

[data-theme="dark"] .notifications_page {
  --notifications-danger: #F87171;
}

/* la feuille de style globale supprime tous les outlines : on rend le focus clavier visible */
.notifications_page :is(button, a, select, [role="switch"]):focus-visible,
.notifications_page .notifications_toggle .toggle-checkbox:focus-visible + .toggle-switch {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.notifications_page .notifications_num {
  font-variant-numeric: tabular-nums;
}

/* ----- structure de page ----- */

.notifications_page .notifications_title_row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin: 32px 0 8px;
}

.notifications_page > .notifications_title_row {
  margin-top: 0;
}

.notifications_page .notifications_title_row h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.notifications_page_title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text-primary);
}

.notifications_page .notifications_hint {
  margin: 0 0 16px;
  max-width: 75ch;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.notifications_page .notifications_card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  padding: 24px;
  margin-bottom: 24px;
}

/* ----- boutons : un seul principal, actions de ligne discrètes, actions destructives en rouge ----- */

.notifications_page .notifications_primary_button,
.notifications_page .notifications_secondary_button,
.notifications_page .notifications_row_button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 16px;
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.notifications_page .notifications_primary_button {
  background-color: var(--primary);
  border: 1px solid var(--primary);
  color: #fff;
}

.notifications_page .notifications_primary_button:hover:not(:disabled) {
  background-color: var(--primary-hover);
  box-shadow: var(--shadow-sm);
}

.notifications_page .notifications_primary_button.notifications_danger_button {
  background-color: var(--notifications-danger);
  border-color: var(--notifications-danger);
}

[data-theme="dark"] .notifications_page .notifications_primary_button.notifications_danger_button {
  color: #1E293B;
}

.notifications_page .notifications_secondary_button,
.notifications_page .notifications_row_button {
  background-color: transparent;
  border: 1px solid var(--border);
  color: var(--text-primary);
}

.notifications_page .notifications_secondary_button:hover:not(:disabled),
.notifications_page .notifications_row_button:hover:not(:disabled) {
  background-color: var(--bg);
}

.notifications_page .notifications_row_button {
  min-height: 32px;
  padding: 0 12px;
  font-size: 13px;
}

.notifications_page .notifications_row_button:hover:not(:disabled) {
  border-color: var(--text-secondary);
}

.notifications_page .notifications_row_button_danger {
  color: var(--notifications-danger);
  border-color: color-mix(in srgb, var(--notifications-danger) 40%, transparent);
}

.notifications_page .notifications_row_button_danger:hover:not(:disabled) {
  background-color: var(--danger-light);
  border-color: var(--notifications-danger);
}

.notifications_page .notifications_primary_button:disabled,
.notifications_page .notifications_secondary_button:disabled,
.notifications_page .notifications_row_button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.notifications_page .notifications_row_actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* ----- interrupteurs ----- */

.notifications_page .notifications_switch_row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.notifications_page .notifications_switch_label p {
  margin: 0;
  font-weight: 600;
  color: var(--text-primary);
}

.notifications_page .notifications_switch_hint {
  margin: -8px 0 0;
  font-size: 13px;
  color: var(--text-secondary);
}

.notifications_page .notifications_toggle {
  position: relative;
}

/* le toggle partagé masque sa case avec visibility, ce qui la retire aussi du clavier : on la garde focusable, juste invisible */
.notifications_page .notifications_toggle .toggle-checkbox {
  visibility: visible;
  opacity: 0;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
  z-index: 1;
}

.notifications_page .notifications_helper {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
  color: var(--text-secondary);
}

@media (prefers-reduced-motion: reduce) {
  .notifications_page *,
  .notifications_page *::before,
  .notifications_page *::after {
    transition-duration: 0.01ms !important;
  }
}

@media (max-width: 768px) {
  .notifications_page .notifications_card {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/notifications/notifications.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E,0FAA0F;AAC1F;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,8FAA8F;AAC9F;;EAEE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA,uGAAuG;;AAEvG;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,uFAAuF;AACzF;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,8EAA8E;AAChF;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iIAAiI;AACjI;EACE,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE;;;IAGE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* ===== Notifications : styles communs à la liste et au formulaire ===== */\n\n/* rouge plus foncé que --danger, pour que le texte blanc atteigne un contraste de 4.5:1 */\n.notifications_page {\n  --notifications-danger: #B91C1C;\n}\n\n[data-theme=\"dark\"] .notifications_page {\n  --notifications-danger: #F87171;\n}\n\n/* la feuille de style globale supprime tous les outlines : on rend le focus clavier visible */\n.notifications_page :is(button, a, select, [role=\"switch\"]):focus-visible,\n.notifications_page .notifications_toggle .toggle-checkbox:focus-visible + .toggle-switch {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.notifications_page .notifications_num {\n  font-variant-numeric: tabular-nums;\n}\n\n/* ----- structure de page ----- */\n\n.notifications_page .notifications_title_row {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin: 32px 0 8px;\n}\n\n.notifications_page > .notifications_title_row {\n  margin-top: 0;\n}\n\n.notifications_page .notifications_title_row h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.notifications_page_title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n}\n\n.notifications_page .notifications_hint {\n  margin: 0 0 16px;\n  max-width: 75ch;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.notifications_page .notifications_card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n/* ----- boutons : un seul principal, actions de ligne discrètes, actions destructives en rouge ----- */\n\n.notifications_page .notifications_primary_button,\n.notifications_page .notifications_secondary_button,\n.notifications_page .notifications_row_button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 36px;\n  padding: 0 16px;\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.notifications_page .notifications_primary_button {\n  background-color: var(--primary);\n  border: 1px solid var(--primary);\n  color: #fff;\n}\n\n.notifications_page .notifications_primary_button:hover:not(:disabled) {\n  background-color: var(--primary-hover);\n  box-shadow: var(--shadow-sm);\n}\n\n.notifications_page .notifications_primary_button.notifications_danger_button {\n  background-color: var(--notifications-danger);\n  border-color: var(--notifications-danger);\n}\n\n[data-theme=\"dark\"] .notifications_page .notifications_primary_button.notifications_danger_button {\n  color: #1E293B;\n}\n\n.notifications_page .notifications_secondary_button,\n.notifications_page .notifications_row_button {\n  background-color: transparent;\n  border: 1px solid var(--border);\n  color: var(--text-primary);\n}\n\n.notifications_page .notifications_secondary_button:hover:not(:disabled),\n.notifications_page .notifications_row_button:hover:not(:disabled) {\n  background-color: var(--bg);\n}\n\n.notifications_page .notifications_row_button {\n  min-height: 32px;\n  padding: 0 12px;\n  font-size: 13px;\n}\n\n.notifications_page .notifications_row_button:hover:not(:disabled) {\n  border-color: var(--text-secondary);\n}\n\n.notifications_page .notifications_row_button_danger {\n  color: var(--notifications-danger);\n  border-color: color-mix(in srgb, var(--notifications-danger) 40%, transparent);\n}\n\n.notifications_page .notifications_row_button_danger:hover:not(:disabled) {\n  background-color: var(--danger-light);\n  border-color: var(--notifications-danger);\n}\n\n.notifications_page .notifications_primary_button:disabled,\n.notifications_page .notifications_secondary_button:disabled,\n.notifications_page .notifications_row_button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.notifications_page .notifications_row_actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* ----- interrupteurs ----- */\n\n.notifications_page .notifications_switch_row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.notifications_page .notifications_switch_label p {\n  margin: 0;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.notifications_page .notifications_switch_hint {\n  margin: -8px 0 0;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.notifications_page .notifications_toggle {\n  position: relative;\n}\n\n/* le toggle partagé masque sa case avec visibility, ce qui la retire aussi du clavier : on la garde focusable, juste invisible */\n.notifications_page .notifications_toggle .toggle-checkbox {\n  visibility: visible;\n  opacity: 0;\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.notifications_page .notifications_helper {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .notifications_page *,\n  .notifications_page *::before,\n  .notifications_page *::after {\n    transition-duration: 0.01ms !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .notifications_page .notifications_card {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
